import { baseApi } from './BaseService';
import {
  CreateIntegrationDefinitionRequest,
  UpdateIntegrationDefinitionRequest,
  IntegrationDefinitionByIdResponse,
  IntegrationDefinitionsResponse,
} from '../responseTypes/integrationDefinitions';

const baseUrl = 'admin/roles';

export const integrationDefinitionsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getRoles: build.query<IntegrationDefinitionsResponse, {}>({
      query: (params) => ({
        url: `${baseUrl}`,
        params,
      }),
      providesTags: ['IntegrationDefinitions'],
    }),

    getRoleById: build.query<IntegrationDefinitionByIdResponse, { roleId: string }>({
      query: ({ roleId }) => ({ url: `${baseUrl}/${roleId}` }),
      providesTags: ['IntegrationDefinitions'],
    }),

    createIntegrationDefinition: build.mutation<
      IntegrationDefinitionByIdResponse,
      { data: CreateIntegrationDefinitionRequest }
    >({
      query: ({ data }) => ({
        url: `${baseUrl}`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['IntegrationDefinitions'],
    }),

    updateIntegrationDefinition: build.mutation<
      IntegrationDefinitionByIdResponse,
      { roleId: string; data: UpdateIntegrationDefinitionRequest }
    >({
      query: ({ roleId, data }) => ({
        url: `${baseUrl}/${roleId}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['IntegrationDefinitions'],
    }),

    deleteIntegrationDefinition: build.mutation<string, { roleId: string }>({
      query: ({ roleId }) => ({
        url: `${baseUrl}/${roleId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['IntegrationDefinitions'],
    }),
  }),
});
